import { render } from "./indexUserComponent.vue?vue&type=template&id=0c4ba807"
import script from "./indexUserComponent.vue?vue&type=script&lang=js"
export * from "./indexUserComponent.vue?vue&type=script&lang=js"

import "./indexUserComponent.vue?vue&type=style&index=0&id=0c4ba807&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/r2-disponibilidade-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__